import { vueInit } from "./main";

vueInit();
